<!-- ADD AND EDIT USER -->
<kendo-dialog *ngIf="isAddUserOpened" class="app-dialog" [width]="750" (close)="onCancel(addUserEmailForm)"
  id="add-edit-user-dialog">
  <kendo-dialog-titlebar>
    {{ isAddRecord ? 'Add User' : 'Edit User' }}
  </kendo-dialog-titlebar>
  <div>
    <form novalidate #addUserEmailForm="ngForm">
      <div>
        <ul class="listContant">
          <li class="validationError" *ngIf="invalidPatternMatch"><span
              class="k-icon k-i-error text-red"></span>{{invalidPatternMatchMsg}}</li>
          <li class="validationError" *ngIf="invalidEmailFormat"><span
              class="k-icon k-i-error text-red"></span>{{invalidEmailFormatMsg}}</li>
        </ul>
      </div>
      <div *ngIf="currentSection === 1">
        <div class="row bottom-margin-0">
          <p class="form-label"><span class="bold headingtext">Confirm Email</span></p>
          <div class="row top-margin-15">
            <div class="col s12 m12 l4 xl4">
              <label for="emailAddress">Email Address<span class="k-required">*</span></label>
            </div>
            <div class="col s12 m12 l6 xl5">
              <input type="text" id="email-Address" placeholder="e.g. myname@example.net" #NewEmailAddress="ngModel"
                name="NewEmailAddress" [(ngModel)]="userEmailData.NewEmailAddress"
                class="k-textbox kendo-textbox input-field" onCopy="return false" onDrag="return false"
                onDrop="return false" onPaste="return false" autocomplete="false" (keyup)="onChange()" required
                ngDefaultControl />
            </div>
          </div>
          <div class="row bottom-margin-0">
            <div class="col s12 m12 l4 xl4">
              <label for="emailAddress">Confirm Email Address<span class="k-required">*</span></label>
            </div>
            <div class="col s12 m12 l6 xl5">
              <input type="text" id="emailAddress" placeholder="e.g. myname@example.net" #ConfirmEmailAddress="ngModel"
                name="ConfirmEmailAddress" [(ngModel)]="userEmailData.ConfirmEmailAddress"
                class="k-textbox kendo-textbox input-field" onCopy="return false" onDrag="return false"
                onDrop="return false" onPaste="return false" autocomplete="false" (keyup)="onChange()" required
                ngDefaultControl />
            </div>
          </div>
        </div>
        <div *ngIf="userRecord && userRecord.activeOrgUser; else validRecord" id="active-user-msg">
          <p>
            <span class="k-icon k-i-warning text-warning"></span>
            {{userRecord.isLocked ? lockedAccount : activeUserMsg}}
          </p>
        </div>
        <ng-template #validRecord>
          <div class="row bottom-margin-0" *ngIf="existingRecords" id="valid-record-msg">
            <div class="col s12 m12 l12 xl12">
              <p>Do you want to add <strong
                  class="bold">"{{userRecord.firstName + " " + userRecord.lastName }}"</strong> to this org?</p>
            </div>
          </div>
          <div class="row bottom-margin-0">
            <!-- IS EXISTING RADIO BUTTON -->
            <div class="col s6 m6 l6 xl6" *ngIf="existingRecords" id="valid-record-options">
              <div class="wrap">
                <input class="k-radio" id="addExisting" type="radio" name="CreateUser" #addExisting value="ExistUser"
                  [(ngModel)]="userEmailData.CreateUser" kendoRadioButton>
                <label class="k-radio-label" for="addExisting" id="add-existing-user">
                  Add Existing User
                </label>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <!-- USER DETAILS -->
      <div *ngIf="currentSection === 2">
        <div *ngIf="userFormData.isLocked && userFormData.activeOrgUser">
          <span class="k-icon k-i-warning"></span>{{lockedAccount}}
        </div>
        <div class="row bottom-margin-0">
          <p class="form-label"><span class="bold headingtext">User Details</span></p>
          <div class="display-none">
            <input type="number" id="id" class="k-textbox kendo-textbox input-field" name="Id"
              [(ngModel)]="userFormData.id" #Id="ngModel" ngDefaultControl />
          </div>
          <div class="row top-margin-15">
            <div class="col s12 m12 l4 xl4">
              <label for="firstName">First Name<span class="k-required">*</span></label>
            </div>
            <div class="col s12 m12 l6 xl5">
              <input type="text" id="firstName" class="k-textbox kendo-textbox input-field" required ngDefaultControl
                name="FirstName" pattern="^[a-zA-Z\s.'\-,`]+$" maxlength="12" [(ngModel)]="userFormData.firstName"
                #FirstName="ngModel" />
              <div class="top-margin-1"
                *ngIf="addUserEmailForm.controls.FirstName?.touched && addUserEmailForm.controls.FirstName.errors">
                <span class="left-margin-0 tooltip-validation">
                  Valid First Name is required
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12 m12 l4 xl4">
              <label for="middleName">Middle Initial</label>
            </div>
            <div class="col s12 m12 l6 xl5">
              <input type="text" id="middleName" class="k-textbox kendo-textbox input-field" name="MiddleName"
                [(ngModel)]="userFormData.middleName" (keyup)="trimContent($event, addUserEmailForm)"
                maxlength="1" #MiddleName="ngModel" ngDefaultControl />
            </div>
          </div>
          <div class="row">
            <div class="col s12 m12 l4 xl4">
              <label for="lastName">Last Name<span class="k-required">*</span></label>
            </div>
            <div class="col s12 m12 l6 xl5">
              <input type="text" id="lastName" class="k-textbox kendo-textbox input-field" name="LastName"
                pattern="^[a-zA-Z\s.'\-,`]+$" maxlength="17" [(ngModel)]="userFormData.lastName" #LastName="ngModel"
                required ngDefaultControl />
              <div class="top-margin-1"
                *ngIf="addUserEmailForm.controls.LastName?.touched && addUserEmailForm.controls.LastName.errors">
                <span class="left-margin-0 tooltip-validation">
                  Valid Last Name is required
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12 m12 l4 xl4">
              <label for="emailAddress">Email Address</label>
            </div>
            <div class="col s12 m12 l6 xl5">
              <input type="text" id="emailAddress" placeholder="e.g. myname@example.net" [disabled]="true"
                class="k-textbox kendo-textbox input-field" name="EmailAddress" [(ngModel)]="userFormData.emailAddress"
                #EmailAddress="ngModel" required ngDefaultControl />
            </div>
          </div>
        </div>
        <!-- USER ROLE -->
        <div class="row bottom-margin-0">
          <p class="form-label"><span class="bold headingtext">User Roles</span></p>
          <div class="row">
            <div class="col s12 m12 l12 xl12" id="user-role-div">
              <div *ngFor="let item of userFormData.roles; let row_no = index;" class="user-roles">
                <div>
                  <input type="checkbox" id="chkbx{{row_no}}" class="k-checkbox" name="chkbx{{item.name}}"
                    [(ngModel)]="item.selected" [disabled]="item.id === 1" />
                  <label for="chkbx{{row_no}}" class="k-checkbox-label"></label>
                </div>
                <div class="role-name">
                  <span>{{item.description}}</span>
                </div>
              </div>
              <div class="top-margin-1">
                <span class="left-margin-0 tooltip-validation" *ngIf="disableRole(addUserEmailForm)">
                  {{rolesValidationMsg}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- CONTACT DETAILS -->
        <div class="row bottom-margin-0">
          <p class="form-label"><span class="bold headingtext">Contact Details</span></p>
          <div class="row">
            <div class="col s12 m12 l12 xl12 contact-details">
              <div class="form-group">
                <div class="input-validation">
                  <div class="row top-margin-1">
                    <div class="col s12 m6 l6 xl6">
                      <label for="phoneNumber1" class="right-margin-10">Phone No. 1<span
                          class="k-required">*</span></label>
                      <kendo-maskedtextbox type="tel" id="phoneNumber1" [mask]="'(000) 000-0000'" name="PhoneNumber"
                        [(ngModel)]="userFormData.phoneNumber" #PhoneNumber="ngModel" required ngDefaultControl>
                      </kendo-maskedtextbox>
                      <div class="top-margin-1"
                        *ngIf="addUserEmailForm.controls.PhoneNumber?.touched && addUserEmailForm.controls.PhoneNumber.errors">
                        <span class="tooltip-validation">
                          Valid phone number is required
                        </span>
                      </div>
                    </div>
                    <div class="col s12 m6 l6 xl6">
                      <label for="extension1" class="right-margin-10">Extension 1</label>
                      <kendo-maskedtextbox id="phoneNumberExtension1" [mask]="'000000'" [maskValidation]="false"
                        name="PhoneNumberExtension" [(ngModel)]="userFormData.phoneNumberExtension"
                        #PhoneNumberExtension="ngModel" ngDefaultControl></kendo-maskedtextbox>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col s12 m6 l6 xl6">
                      <label for="phoneNumber2" class="right-margin-10">Phone No. 2</label>
                      <kendo-maskedtextbox type="tel" id="phoneNumber2" [mask]="'(000) 000-0000'" name="PhoneNumber2"
                        [(ngModel)]="userFormData.phoneNumber2" #PhoneNumber2="ngModel" ngDefaultControl>
                      </kendo-maskedtextbox>
                    </div>
                    <div class="col s12 m6 l6 xl6">
                      <label for="extension2" class="right-margin-10">Extension 2</label>
                      <kendo-maskedtextbox id="phoneNumberExtension2" [mask]="'000000'" [maskValidation]="false"
                        name="PhoneNumber2Extension" [(ngModel)]="userFormData.phoneNumber2Extension"
                        #PhoneNumber2Extension="ngModel" ngDefaultControl></kendo-maskedtextbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" [disabled]="isProcessing" (click)="onCancel(addUserEmailForm)" id="cancel-btn"
      *ngIf="(currentSection === 1 || !isAddRecord); else prevbtn">Cancel</button>
    <ng-template #prevbtn>
      <button kendoButton class="k-button" [disabled]="isProcessing" (click)="onPrevious()"
        id="previous-btn">Previous</button>
    </ng-template>
    <button kendoButton class="k-button k-primary" *ngIf="currentSection === 1; else savebtn"
      [disabled]="disableNext(addUserEmailForm)" id="next-btn" (click)="onNext()">Next</button>
    <ng-template #savebtn>
      <button kendoButton id="create-update-btn" (click)="onSave(addUserEmailForm)"
        [disabled]="disableSave(addUserEmailForm) || isProcessing">
        <span *ngIf="!isProcessing">{{ isAddRecord ? 'Create' : 'Update' }}</span>
        <span *ngIf="isProcessing" class="k-icon k-i-loading inner"></span>
      </button>
    </ng-template>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- PLEASE CONFIRM DIALOG -->
<kendo-dialog title="Please Confirm" class="app-dialog" *ngIf="isConfirmOpened" (close)="isConfirmOpened = false" [minWidth]="450" id="confirm-dialog">
  <p class="dialog-heading margin-30 align-center">All unsaved changes will be lost. <br> Are you sure you want to
    continue?</p>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" id="confirm-dialog-no" (click)="isConfirmOpened = false">No</button>
    <button kendoButton class="k-button" id="confirm-dialog-yes" (click)="close('yes')" primary="true">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
